import { DispatchType } from '../../../@types/redux-types'
import { getUser } from '../../../api/user/userApi'
import { getUserInitialCompletionSuccess } from '../../reducers/insertion/insertionFeature'
import { showMessage } from '../../reducers/message/messageFeature'
import NotLoggedInError from '../../../services/domain/errors/NotLoggedInError'
import { doSsoRedirect } from '../login/login'
import { getUserSuccess } from '../../reducers/user/userFeature'
import { isWebView } from '../../../utils/navigation'

type GetUserInitialCompletionOptions = {
  redirectOnUnauthorized?: boolean
}

export const getUserInitialCompletion =
  ({ redirectOnUnauthorized = true }: GetUserInitialCompletionOptions = {}) =>
  async (dispatch: DispatchType) => {
    try {
      const user = await getUser()
      dispatch(getUserInitialCompletionSuccess({ user: user, prefillPhoneNumber: !isWebView() }))
      dispatch(getUserSuccess({ user: user }))
      return true
    } catch (error) {
      if (error instanceof NotLoggedInError) {
        if (redirectOnUnauthorized) {
          doSsoRedirect()
        }
      } else {
        dispatch(showMessage({ message: 'unknown' }))
      }
      return false
    }
  }
